var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13672 1.8125C4.71946 1.8125 1.94922 4.58274 1.94922 8C1.94922 11.4173 4.71946 14.1875 8.13672 14.1875C11.554 14.1875 14.3242 11.4173 14.3242 8C14.3242 4.58274 11.554 1.8125 8.13672 1.8125ZM0.824219 8C0.824219 3.96142 4.09814 0.6875 8.13672 0.6875C12.1753 0.6875 15.4492 3.96142 15.4492 8C15.4492 12.0386 12.1753 15.3125 8.13672 15.3125C4.09814 15.3125 0.824219 12.0386 0.824219 8ZM7.38672 4.625C7.38672 4.21079 7.72251 3.875 8.13672 3.875C8.55093 3.875 8.88672 4.21079 8.88672 4.625C8.88672 5.03921 8.55093 5.375 8.13672 5.375C7.72251 5.375 7.38672 5.03921 7.38672 4.625ZM8.69922 11.75V6.5H7.57422V11.75H8.69922Z",
    fill: "#3E3E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.8f4037a95bb5fe8ed47730ba17c18ba7.svg";
export { ForwardRef as ReactComponent };